import { useEffect, useState } from 'react';

import { observer } from 'mobx-react';
import { Space } from '@bringg/react-components';
import moment from 'moment';
import { useHasFeatureFlag } from '@bringg-frontend/hooks';

import { useStores } from 'bringg-web/recipes';
import Page from './components/page/page';
import FiltersPanel from './components/filters-panel/filters-panel';
import { useHistoryTranslation } from './translations';
import HistoryTable from './components/history-table/history-table';
import { DISABLE_FETCH_COUNT_FEATURE_FLAG } from './components/history-table/pagination';

const INITIAL_VALUES = {
	ended_time: [moment().subtract(6, 'd').startOf('day'), moment().endOf('day')]
};

const HistoryPage = observer(() => {
	const { teamsStore, tagsStore, fleetsStore, servicePlansStore } = useStores();
	const translations = useHistoryTranslation();
	const disableFetchCount = useHasFeatureFlag(DISABLE_FETCH_COUNT_FEATURE_FLAG);

	const [filters, setFilters] = useState(disableFetchCount ? INITIAL_VALUES : {});

	useEffect(() => {
		const init = async () =>
			Promise.all([
				teamsStore.fetchAll(),
				tagsStore.fetchAll(),
				fleetsStore.fetchAll(),
				servicePlansStore.fetchAll()
			]);

		init();
	}, [disableFetchCount]);

	return (
		<Page title={translations.pageTitle}>
			<Space direction="vertical" style={{ display: 'flex' }}>
				<FiltersPanel onFilter={setFilters} initialValues={disableFetchCount ? INITIAL_VALUES : null} />
				<HistoryTable filters={filters} />
			</Space>
		</Page>
	);
});

export default HistoryPage;
